import produce from 'immer';
import { startCase } from 'lodash';

import ReactSelect from 'dashboard/components/ReactSelect';
import { RiskConfigCheckConfig, RiskLevel } from 'dashboard/models/verification-check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import { Label } from 'design-system/components/Text';

interface UpdateRiskTriggerLevelProps {
  checkConfig: RiskConfigCheckConfig;
  editable: boolean;
  handleUpdateCheck: (check: VerificationCheckConfig) => void;
}

const UpdateRiskTriggerLevel = ({
  checkConfig,
  editable,
  handleUpdateCheck,
}: UpdateRiskTriggerLevelProps) => {
  if (!checkConfig['risk-configs']) return null;
  const enabledRiskConfigs = checkConfig['risk-configs'].filter((riskConfig) => riskConfig.enabled);
  if (enabledRiskConfigs.length > 0) {
    return (
      <>
        {enabledRiskConfigs.map((riskConfig) => {
          const riskCategory = riskConfig.category;
          const updateRiskTriggerLevel = (riskLevel: RiskLevel) => {
            const check = produce(checkConfig, (draftCheckConfig) => {
              const riskConfigIndex = checkConfig['risk-configs'].findIndex(
                (riskConfig) => riskConfig.category === riskCategory,
              );
              draftCheckConfig['risk-configs'][riskConfigIndex]['trigger-level'] = riskLevel;
            });
            handleUpdateCheck(check);
          };
          return (
            <div key={riskCategory}>
              <Label color={editable ? 'primary' : 'disabled'}>
                {`${startCase(riskCategory)} Risk Threshold`}
              </Label>
              <ReactSelect
                options={Object.values(RiskLevel)
                  .reverse()
                  .map((riskLevel) => {
                    return {
                      label: startCase(riskLevel),
                      value: riskLevel,
                    };
                  })}
                value={riskConfig['trigger-level']}
                isDisabled={!editable}
                onChange={updateRiskTriggerLevel}
              />
            </div>
          );
        })}
      </>
    );
  }

  return null;
};

export default UpdateRiskTriggerLevel;
